import {DomainEvent} from './DomainEvent';
import {TeamSeason} from '../resources/TeamSeason';

export class TeamSeasonCreated extends DomainEvent<TeamSeason> {}
